import $ from "jquery";
import TemplateView from "./TemplateView";
import KEY_HANDLERS from "./keyHandlers/index";
import {isIE8, showElementAt, cancelBubble} from "./atBrowserUtils";
import {KEY_CODE_ESC, KEY_CODE_TAB} from "./keyCodes";

export default class DropdownTemplateView extends TemplateView {
    constructor($containerEl, {
        toggleMode = true,
        onHide = () => {},
        onShow = () => {},
    } = {}) {
        super($containerEl);

        this.params = {
            toggleMode,
            onHide,
            onShow,
        }
    }

    showAt($element, positionParams, $positionEl) {
        if (!$positionEl)
            $positionEl = $element;

        // prevent next showing if closed by mouse down to $element
        if (this.params.toggleMode && this.ignoreNextShowing) {
            this.ignoreNextShowing = false;
            return;
        }

        const ie8 = isIE8();
        if (ie8) {
            this.lastWindowWidth = $(window).width;
            this.lastWindowHeight = $(window).height;
        }

        this._registerHideHandlers()

        this.update();// update before show

        this.$elementShowAt = $element;
        positionParams = positionParams || {};
        positionParams.of = $positionEl;
        this.show()
        this._showElementAt(this.$el, positionParams);
        if (!this.isShown) {
            this.isShown = true;
            this.onShow();
        }
    }

    _registerHideHandlers() {
        this.mouseDownTargetElement().on("mousedown.dropdownList", $.proxy(this._mouseDownHandler, this));
        $(window).on("resize.dropdownList", $.proxy(isIE8() ? this._resizeIE8Handler : this._resizeHandler, this));
    }

    mouseDownTargetElement() {
        return this.$containerEl
    }

    _mouseDownIgnoreElement() {
        return this.$el
    }

    _showElementAt($el, positionParams) {
        showElementAt($el, positionParams);
    }

    onShow() {
        this._removeKeydownHandler = KEY_HANDLERS.onKeyDown(this._keyDownHandler)
        if (this.params.onShow) this.params.onShow()
    }

    onHide() {
        if (this._removeKeydownHandler)
            this._removeKeydownHandler();
    }

    _isPossibleToHide() {
        return true
    }

    hide(force = false) {
        if (this.isShown && (force || this._isPossibleToHide())) {
            this.isShown = false;
            super.hide()
            this.$el.hide();

            this.mouseDownTargetElement().off("mousedown.dropdownList");
            $(window).off("resize.dropdownList");
            this.$containerEl.off("keydown.dropdownList");
            this.onHide();
            if (this.params.onHide) this.params.onHide()
        }
    }

    _resizeHandler() {
        this.hide();
    }

    _resizeIE8Handler() {
        if ($(window).width() !== this.lastWindowWidth || $(window).height() !== this.lastWindowHeight) {
            this.lastWindowWidth = $(window).width();
            this.lastWindowHeight = $(window).height();
            this.hide();
        }
    }

    _scrollHandler() {
        this.hide();
    }

    _keyDownHandler = (keycode, event) => {
        if (this.isShown) {
            switch (keycode) {
                case KEY_CODE_ESC:
                case KEY_CODE_TAB:
                    this.hide();
                    return true;
            }
        }
    }

    _mouseDownHandler(event) {
        if (this.isShown) {
            let target = event.target;
            while (target) {
                if (target === this.$elementShowAt[0]) {
                    this.ignoreNextShowing = true;
                }
                if (target === this._mouseDownIgnoreElement()[0]) {
                    return
                }
                target = target.parentElement;
            }
            cancelBubble(event);
            this.hide();
            event.preventDefault();
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/DropdownTemplateView.js